import hexRgb from 'hex-rgb';
import iwanthue from 'iwanthue';

export const generatePallete = (colorCount) => {
  const colors = iwanthue(colorCount, {
    colorSpace: [0, 360, 0, 100, 0, 100],
    clustering: 'k-means',
    quality: 100,
  });

  return colors;
};

export const isColorLight = (hexColor) => {
  const {red, green, blue, alpha} = hexRgb(hexColor);

  // Counting the perceptive luminance
  // human eye favors green color...
  const a = 1 - (0.299 * red + 0.587 * green + 0.114 * blue) / 255 / alpha;

  return a < 0.5;
};
